var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoBatchName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11260_48344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62072 10.3274C6.56124 10.0968 6.44105 9.88642 6.27267 9.71804C6.10429 9.54965 5.89386 9.42947 5.66328 9.36998L1.57567 8.31593C1.50593 8.29614 1.44455 8.25414 1.40085 8.1963C1.35714 8.13846 1.3335 8.06795 1.3335 7.99546C1.3335 7.92296 1.35714 7.85245 1.40085 7.79461C1.44455 7.73677 1.50593 7.69477 1.57567 7.67498L5.66328 6.62026C5.89378 6.56083 6.10415 6.44075 6.27253 6.27249C6.4409 6.10423 6.56113 5.89394 6.62072 5.66349L7.67477 1.57588C7.69436 1.50586 7.73632 1.44418 7.79425 1.40024C7.85217 1.3563 7.92288 1.33252 7.99558 1.33252C8.06829 1.33252 8.13899 1.3563 8.19692 1.40024C8.25484 1.44418 8.2968 1.50586 8.3164 1.57588L9.36978 5.66349C9.42926 5.89407 9.54945 6.10449 9.71783 6.27287C9.88621 6.44126 10.0966 6.56144 10.3272 6.62093L14.4148 7.67431C14.4851 7.6937 14.5471 7.73561 14.5913 7.79362C14.6355 7.85164 14.6594 7.92254 14.6594 7.99546C14.6594 8.06837 14.6355 8.13927 14.5913 8.19729C14.5471 8.2553 14.4851 8.29721 14.4148 8.3166L10.3272 9.36998C10.0966 9.42947 9.88621 9.54965 9.71783 9.71804C9.54945 9.88642 9.42926 10.0968 9.36978 10.3274L8.31573 14.415C8.29614 14.485 8.25418 14.5467 8.19625 14.5907C8.13833 14.6346 8.06762 14.6584 7.99492 14.6584C7.92221 14.6584 7.85151 14.6346 7.79358 14.5907C7.73566 14.5467 7.6937 14.485 7.6741 14.415L6.62072 10.3274Z",
    strokeWidth: 1.33255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3257 1.99902V4.66413",
    strokeWidth: 1.33255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6583 3.33154H11.9932",
    strokeWidth: 1.33255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.66504 11.3267V12.6592",
    strokeWidth: 1.33255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33158 11.9932H1.99902",
    strokeWidth: 1.33255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11260_48344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9906,
    height: 15.9906
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoBatchName);
export default __webpack_public_path__ + "static/media/auto-batch-name.90bb16bc.svg";
export { ForwardRef as ReactComponent };